import React, { useMemo, useState } from 'react';
import StockStatus from '../StockStatus';
import Price from '../Price';
import { translate } from '../../Services/translation';
import BuyButtonContainer from '../../Containers/BuyButton.container';
import useBreakpoint from '../../Hooks/useBreakpoint';
import useEcommerceDisabled from '../../Hooks/useEcommerceDisabled';

const ListCardSmall = (props) => {
  const {
    id: articleNumber,
    articleNumberLabel,
    name,
    boxQuantity,
    packageSize,
    price,
    url,
    parentCategory,
    isInStock,
    stockStatusDescripton,
    isAuthenticated,
    quantity,
    currency,
    stockMessage,
  } = props;
  const ecommerceDisabled = useEcommerceDisabled();
  const [ buyQuantity, setBuyQuantity ] = useState(0);

  return isAuthenticated ? (
    <div className="list-product-card">
      <div className="list-product-card__top">
        {name && (
          <a className="list-product-card__title" href={url}>
            {name}
          </a>
        )}
        {parentCategory && (
          <div className="list-product-card__category">{parentCategory}</div>
        )}
        <div className="list-product-card__artno-and-units">
          {articleNumber && (
            <a className="list-product-card__artno" href={url}>
              {translate('product.artno')}: {articleNumberLabel}
            </a>
          )}
          {boxQuantity && (
            <div className="list-product-card__units">
              {translate('product.units')}: {boxQuantity}
            </div>
          )}
        </div>
      </div>
      <div className="list-product-card__stock-and-price">
        {!ecommerceDisabled && (
          <StockStatus
            inStock={isInStock}
            description={stockStatusDescripton}
            showInfoBox={!isInStock}
            stockMessage={stockMessage}
          />
        )}
        {price && (
          <Price
            price={price}
            packageSize={packageSize}
            currency={currency}
            disableTierPriceTooltip={true}
            showForQuantity={buyQuantity}
            className="price__wrapper--old-price-right"
          />
        )}
      </div>
      {!ecommerceDisabled && (
        <BuyButtonContainer
          buyButtonClassName="buy-button--square"
          articleNumber={articleNumber}
          packageSize={packageSize}
          wishList={{ articleNumber, quantity }}
          onChangeQuantity={newQuantity => setBuyQuantity(newQuantity)}
        />
      )}
    </div>
  ) : (
    <div className="list-product-card">
      <div className="list-product-card__top">
        {name && (
          <a className="list-product-card__title" href={url}>
            {name}
          </a>
        )}
        <div className="list-product-card__artno-and-units">
          {articleNumber && (
            <a className="list-product-card__artno" href={url}>
              {translate('product.artno')}: {articleNumberLabel}
            </a>
          )}
          {boxQuantity && (
            <div className="list-product-card__units">
              {translate('product.units')}: {boxQuantity}
            </div>
          )}
        </div>
      </div>
      {!ecommerceDisabled && (
        <BuyButtonContainer
          buyButtonClassName="buy-button--square"
          articleNumber={articleNumber}
          packageSize={packageSize}
          onChangeQuantity={newQuantity => setBuyQuantity(newQuantity)}
        />
      )}
    </div>
  );
};

const ListCardDefault = (props) => {
  const {
    id: articleNumber,
    articleNumberLabel,
    name,
    boxQuantity,
    packageSize,
    price,
    url,
    parentCategory,
    isInStock,
    stockStatusDescripton,
    isAuthenticated,
    quantity,
    currency,
    stockMessage,
  } = props;
  const ecommerceDisabled = useEcommerceDisabled();
  const [ buyQuantity, setBuyQuantity ] = useState(0);

  return isAuthenticated ? (
    <div className="list-product-card">
      <div className="list-product-card__left">
        <div className="list-product-card__info">
          {name && (
            <a className="list-product-card__title" href={url}>
              {name}
            </a>
          )}
          {parentCategory && (
            <div className="list-product-card__category">
              {parentCategory}
            </div>
          )}
          {articleNumber && (
            <a className="list-product-card__artno" href={url}>
              {translate('product.artno')}: {articleNumberLabel}
            </a>
          )}
          {boxQuantity && (
            <div className="list-product-card__units">
              {translate('product.units')}: {boxQuantity}
            </div>
          )}
          <div className="list-product-card__stock">
            {!ecommerceDisabled && (
              <StockStatus
                inStock={isInStock}
                description={stockStatusDescripton}
                showInfoBox={!isInStock}
                stockMessage={stockMessage}
              />
            )}
          </div>
        </div>
        {articleNumber && (
          <a className="list-product-card__artno-col" href={url}>
            {articleNumberLabel}
          </a>
        )}
        <div className="list-product-card__stock-col">
          {!ecommerceDisabled && (
            <StockStatus
              inStock={isInStock}
              description={stockStatusDescripton}
              showInfoBox={!isInStock}
              stockMessage={stockMessage}
            />
          )}
        </div>
        {boxQuantity && (
          <div className="list-product-card__units-col">{boxQuantity}</div>
        )}
      </div>
      <div className="list-product-card__right">
        {!ecommerceDisabled ? (
          <>
            {price && (
              <Price
                price={price}
                packageSize={packageSize}
                currency={currency}
                disableTierPriceTooltip={true}
                showForQuantity={buyQuantity}
                className="price__wrapper--old-price-right"
              />
            )}

            <BuyButtonContainer
              buyButtonClassName="buy-button--square"
              articleNumber={articleNumber}
              packageSize={packageSize}
              wishList={{ articleNumber, quantity }}
              onChangeQuantity={newQuantity => setBuyQuantity(newQuantity)}
            />
          </>
        ) : (
          <a href={url} className="product-card__anchor-button">
            {translate('product.view-product')}
          </a>
        )}
      </div>
    </div>
  ) : (
    <div className="not-auth-list-product-card">
      <div className="not-auth-list-product-card__left">
        <div className="not-auth-list-product-card__info">
          {name && (
            <a className="not-auth-list-product-card__title" href={url}>
              {name}
            </a>
          )}
          {parentCategory && (
            <div className="not-auth-list-product-card__category">
              {parentCategory}
            </div>
          )}
          {articleNumber && (
            <a className="not-auth-list-product-card__artno" href={url}>
              {translate('product.artno')}: {articleNumberLabel}
            </a>
          )}
          {boxQuantity && (
            <div className="not-auth-list-product-card__units">
              {translate('product.units')}: {boxQuantity}
            </div>
          )}
        </div>
        {articleNumber && (
          <a className="not-auth-list-product-card__artno-col" href={url}>
            {articleNumberLabel}
          </a>
        )}
        {boxQuantity && (
          <div className="not-auth-list-product-card__units-col">
            {boxQuantity}
          </div>
        )}
      </div>
      <div className="not-auth-list-product-card__right">
        {!ecommerceDisabled ? (
          <BuyButtonContainer
            buyButtonClassName="buy-button--square"
            articleNumber={articleNumber}
            packageSize={packageSize}
            onChangeQuantity={newQuantity => setBuyQuantity(newQuantity)}
          />
        ) : (
          <a href={url} className="product-card__anchor-button">
            {translate('product.view-product')}
          </a>
        )}
      </div>
    </div>
  );
};

const ListProductCard = (props) => {
  const currentBreakpoint = useBreakpoint();

  return currentBreakpoint === 'sm' ? <ListCardSmall {...props} /> : <ListCardDefault {...props} />;
};

export default ListProductCard;
